<template>
  <div class="aboutproducts">
    <div class="aboutproducts-header animate__animated animate__backInLeft">
      <img :src="topImg" :alt="$i18n.locale === 'en-US' ? 'GZZHYUN products banner' : '智会云产品中心横幅'">
    </div>
    <div class="aboutproducts-center">
      <div class="title animate__animated animate__fadeInDown animate__delay-1s">
        <!-- <div class="title-English"><span style="margin-right:20px">PRODUCT</span><span>CENTER</span></div> -->
        <div>{{$t('products.productCenter')}}</div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { getWebTopBackground } from '@/api/editProducts'
export default {
  data () {
    return {
      topImg: ''// 顶部图片
    }
  },
  mounted () {
    this.getTopBackground()
    this.$nextTick(() => {
      this.$wow.init()
    })
  },
  methods: {
    // 获取顶部图片
    getTopBackground () {
      getWebTopBackground().then(res => {
        if (res.code == 0) {
          this.topImg = res.data.value
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.aboutproducts{
  min-height: 600px;
  .aboutproducts-header{
    width: 100%;
    img{
      width: 100%;
      height: auto;
      display: block;
    }
  }
  .aboutproducts-center{
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
    box-sizing: border-box;
    margin-top: 35px;
    .title{
      text-align: center;
      font-size: 26px;
      color: black;
      letter-spacing: 5px;
      line-height: 40px;
      margin-bottom: 30px;
      .title-English{
        font-family: cursive;
      }
    }
  }
}

@media (max-width: 1199.98px) {
  .aboutproducts-center {
    padding: 0 15px;
  }
}

@media (max-width: 767.98px) {
  .aboutproducts {
    .aboutproducts-center {
      margin-top: 20px;

      .title {
        font-size: 18px;
        line-height: 30px;
        letter-spacing: 2px;
        margin-bottom: 20px;

        .title-English {
          font-size: 14px;
          word-break: break-word;
        }
      }
    }
  }
}
</style>
